import { toCamelCase } from '../../../../../utils/toCamelCase.js';

export const appActionArgumentKey = {
  key: 'appActionArgumentKey',
  type: 'app',
  label: 'Argument Key',
  description: 'Suggests a fix for the key of an argument based on the external key change',
  path: 'actions[id:{{actionId}}].arguments[id:{{argumentId}}].key',
  shouldRun: ({ changes }) => {
    return changes?.some((change) => change?.path?.includes('arguments') && change?.path?.endsWith('externalKey'));
  },
  handler: async ({ action, changes }) => {
    const change = changes?.find((change) => change?.path?.includes('arguments') && change?.path?.endsWith('externalKey'));
    const formattedKey = toCamelCase(change?.value || '');
    const argument = action?.arguments?.find((argument) => argument?.id === change?.path?.split('arguments[id:')[1]?.split(']')[0]);

    if (formattedKey === argument?.key) {
      return { success: true, data: { needsSuggestion: false } };
    }

    return {
      success: true,
      data: { needsSuggestion: true, suggestedValue: formattedKey }
    };
  }
};
